export default __webpack_public_path__ + "static/header-c83b2f27266233f5c50a6764c2c9e075.jpg";